/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// import { pxToEm, imageTypes } from 'utils/styles';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// PERCENTAGE BAR STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default {
	percentagebar: {
		borderRadius: 'inherit',
		display: 'block',
		width: '100%',
		height: '100%',
		position: 'absolute',
		bottom: '0',
		left: '50%',
		transform: 'translateX(-50%)',
		zIndex: '1'
	}
};